import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * Store for managing the flow builder state
 */
export const useFlowBuilderStore = defineStore('flowBuilder', () => {
  // State
  // isDragging stores the currently dragged node data or null when not dragging
  const isDragging = ref<{ node: any; isExisting?: boolean } | null>(null)
  
  // Heat map display state
  const showHeatMap = ref(false)
  
  // Path flow visualization state
  const showPathFlow = ref(false)
  
  // Toggle heat map display
  const toggleHeatMap = () => {
    showHeatMap.value = !showHeatMap.value
  }
  
  // Toggle path flow display
  const togglePathFlow = () => {
    showPathFlow.value = !showPathFlow.value
  }

  return {
    isDragging,
    showHeatMap,
    showPathFlow,
    toggleHeatMap,
    togglePathFlow
  }
})
